module.exports = __webpack_public_path__ + "91fc3d8d84b339b5e2a973ff873adf17.png";